import { TechniqueQuestions } from '../global'

export function order(a: TechniqueQuestions, b: TechniqueQuestions): number {
    if (b.requiredTechniques.includes(a.uuid)) {
        return -1
    }

    if (a.requiredTechniques.includes(b.uuid)) {
        return 1
    }

    const impactA = a.icon_economy || 0
    const impactB = b.icon_economy || 0

    if (impactA < impactB) {
        return -1
    }

    if (impactA > impactB) {
        return 1
    }

    const costA = a.icon_cost || 0
    const costB = b.icon_cost || 0

    return costA > costB ? 1 : -1
}
